import { NavLink } from "react-router-dom";

const tabs = [
  { label: "首页", to: "/", icon: "ri-home-5-line", iconActive: "ri-home-5-fill" },
  { label: "电影", to: "/category/movie", icon: "ri-film-line", iconActive: "ri-film-fill" },
  { label: "电视剧", to: "/category/series", icon: "ri-tv-2-line", iconActive: "ri-tv-2-fill" },
  { label: "搜索", to: "/search", icon: "ri-search-line", iconActive: "ri-search-line" },
  { label: "关于", to: "/about", icon: "ri-information-line", iconActive: "ri-information-fill" },
];

export default function MobileTabBar() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-background-200 bg-background-50/98 backdrop-blur md:hidden">
      <ul className="flex items-stretch justify-around">
        {tabs.map((tab) => (
          <li key={tab.to} className="flex-1">
            <NavLink
              to={tab.to}
              end={tab.to === "/"}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${
                  isActive ? "text-primary-600" : "text-foreground-400"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <i
                    className={`${isActive ? tab.iconActive : tab.icon} text-xl`}
                    aria-hidden="true"
                  ></i>
                  {tab.label}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}